module.exports = __webpack_public_path__ + "img/wettbewerb.ce8a0bda.jpg";